import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import React from "react";
import BackgroundStepNumber from "../common/BackgroundStepNumber";
import BedBuilderHeader from "../common/BedBuilderHeader";

import BedBuilderNextButton from "../common/BedBuilderNextButton";

import UnitInput from "../../../../components/Inputs/UnitInput";
import SleepStyles from "./SleepStyles";

import {
  mattressConfigurationSelector, primarySleeperPrimarySleepStyleSelector,
  updateMattressConfiguration,
} from "../../../../redux/slices/mattressConfiguration";
import {
  metaFieldIdSelector,
  shopifyCustomerSelector,
} from "../../../../redux/slices/customer";
import {
  checkErrorsSelector,
  setCurrentStepSingleSleeperMattressBuilder,
  setIsSummaryModalOpen,
} from "../../../../redux/slices/customNavigation";

import styled from "styled-components";
import useMediaQuery from "@mui/material/useMediaQuery";
import {saveMattressConfigurationToLocalStorage} from "../../../../utils/bedBuilder.utils";

const StyledContainer = styled.div`
  position: absolute;
  left: 0;
  top: 35%;
  width: 100%;
  height: 66%;
  overflow: auto;
`;

const StyledSettingsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const SingleSleeperSleepStyle = ({
  currentStepSingleSleeperMattressBuilder,
  index,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  //Media Queries
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const dispatch = useDispatch();
  const shopifyCustomer = useSelector(shopifyCustomerSelector);
  const metaFieldId = useSelector(metaFieldIdSelector);
  const mattressConfiguration = useSelector(mattressConfigurationSelector);
  const primarySleeperPrimarySleepStyle = useSelector(
    primarySleeperPrimarySleepStyleSelector
  );
  const primarySleeperSecondarySleepStyle = useSelector(
    state => state.mattressConfiguration.mattressBuilder.primarySleeper.secondarySleepStyle
  );
  const checkErrors = useSelector(checkErrorsSelector);

  const handleUpdateMattressConfiguration = () => {
    const newMattressConfiguration = {
      metaFieldId: metaFieldId,
      id: shopifyCustomer.id,
      mattressConfiguration: mattressConfiguration,
    };
    dispatch(updateMattressConfiguration(newMattressConfiguration));
  };

  const errorColor1 = (primarySleeperPrimarySleepStyle === null && checkErrors) ? "red" : theme.COLORS.BLUE.darkBlueGreen;
  const errorColor2 = (primarySleeperSecondarySleepStyle === null && checkErrors) ? "red" : theme.COLORS.BLUE.darkBlueGreen;

  return (
    <>
      <StyledContainer style={{ zIndex: 500, overflow: "visible" }}>
        <BackgroundStepNumber>{t("2")}</BackgroundStepNumber>
      </StyledContainer>
      <StyledContainer style={{ zIndex: 600 }}>
        <StyledSettingsContainer className="mx-2">
          <BedBuilderHeader styles={{ marginTop: "1rem", color: errorColor1 }} className={"primary-sleep-style-header"}>
            {t("What Is Your Primary Sleep Style?")}
          </BedBuilderHeader>
          <SleepStyles editingSleeper1 primary></SleepStyles>
          <BedBuilderHeader styles={{ marginTop: "1rem", color: errorColor2 }}>
            {t("What Is Your Secondary Sleep Style?")}
          </BedBuilderHeader>
          <SleepStyles editingSleeper1></SleepStyles>
          <div
            style={
              isMediumScreen
                ? { width: "98%", marginTop: "1.5rem", marginBottom: "1rem" }
                : { marginTop: "2rem", width: "100%", marginBottom: "2rem" }
            }
          >
            <BedBuilderNextButton
              styles={{
                position: "relative",
                bottom: "5%",
                right: "5%",
                color: theme.COLORS.BLUE.darkBlueGreen,
                borderColor: theme.COLORS.BLUE.darkBlueGreen,
              }}
              onClick={() => {
                //Update in local storage
                // console.log("saving to local storage");
                saveMattressConfigurationToLocalStorage(mattressConfiguration);
                handleUpdateMattressConfiguration();

                dispatch(
                  setCurrentStepSingleSleeperMattressBuilder(
                    currentStepSingleSleeperMattressBuilder + 1
                  )
                );
              }}
            ></BedBuilderNextButton>
          </div>
        </StyledSettingsContainer>
      </StyledContainer>
    </>
  );
};

export default SingleSleeperSleepStyle;
